<template>
    <div class="modal-add-certificate">
        <div v-if="showModal">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Datos del diploma</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true" @click="toggleModal()">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <form action="#" @submit.prevent="submit">
                                    <div class="form-row">
                                        <div class="form-group col-12 col-md-6">
                                            <label for="name" class="col-md-4 col-form-label text-md-right">Nombre</label>
                                            <input
                                                id="name"
                                                type="text"
                                                class="form-control"
                                                name="name"
                                                value
                                                required
                                                autofocus
                                                v-model="name"
                                            />
                                        </div>
                                        <div class="form-group col-12 col-md-6">
                                            <label for="lastname" class="col-md-4 col-form-label text-md-right">Apellido</label>
                                            <input
                                                id="lastname"
                                                type="text"
                                                class="form-control"
                                                name="lastname"
                                                value
                                                required
                                                autofocus
                                                v-model="lastname"
                                            />
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-12">
                                            <label for="email" class="col-12 col-form-label text-left">Email</label>
                                            <input
                                                id="email"
                                                type="email"
                                                class="form-control"
                                                name="email"
                                                value
                                                autofocus
                                                v-model="email"
                                            />
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-12 col-md-6" v-if="this.userAction != 'edit'">
                                            <label for="" class="col-12 col-form-label text-left">Emitido</label>
                                            <datepicker :language="es" :input-class="inputClass" v-model="issued" :required="true" format="d MMMM yyyy"></datepicker>
                                        </div>
                                        <div class="form-group col-12 col-md-6">
                                            <label for="galileoCode" class="col-12 col-form-label text-left">Código Galileo</label>
                                            <input
                                                id="galileoCode"
                                                type="text"
                                                class="form-control"
                                                name="galileoCode"
                                                value
                                                required
                                                autofocus
                                                v-model="galileoCode"
                                            />
                                        </div>
                                    </div>

                                    <div class="form-row" v-if="this.userAction != 'edit'">
                                        <div class="form-group col-12">
                                            <label for="course" class="col-12 col-form-label text-left">Curso</label>
                                            <select v-model="course" class="form-control" required>
                                                <option disabled value="">Seleccionar uno...</option>
                                                <option v-for="item in courses" :value="item.id" :key="item.id">{{item.name}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-12">
                                            <label for="achievement" class="col-12 col-form-label text-left">Logros</label>
                                            <textarea
                                                id="achievement"
                                                class="form-control"
                                                name="achievement"
                                                value
                                                autofocus
                                                rows="3"
                                                v-model="achievement"
                                            ></textarea>
                                        </div>
                                    </div>

                                    <div class="form-group row mt-4 mb-0">
                                        <div class="col-12 text-center">
                                            <button v-if="actionBtn =='add'" type="submit" class="btn btn-primary">Guardar</button>
                                            <span v-if="actionBtn =='update'" @click="updateUser(userData.id)" class="btn btn-primary">Actualizar</span>
                                            <span v-if="actionBtn =='update'" @click="toggleModal()" class="btn btn-outline-primary">Cancelar</span>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import firebase from "firebase/app"
import 'firebase/firestore'
import 'firebase/storage'
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js"
import { es } from "vuejs-datepicker/src/locale"

export default {
    name: "ModalAddCertificate",
    created() {
        this.getCourses()
    },
    computed: {
        showModal() {
            return this.$store.getters.addCertificateShow
        },
        userAction() {
            return this.$store.getters.getUserAction
        },
        userData() {
            return this.$store.getters.pdfCertificate
        },
        actionTrigger() {
            return this.$store.getters.userActionTrigger
        },
        courses() {
            return this.$store.getters.activeCourses
        },
        certificate() {
            return this.$store.getters.currentCertificate
        },
        name: {
            get() {
              if(this.userAction == "add") return ""
              return this.$store.getters.currentCertificate.name
            },
            set(value) {
              this.$store.commit("editCertificate", { name: value })
            }
        },
        lastname: {
            get() {
              if(this.userAction == "add") return ""
              return this.$store.getters.currentCertificate.lastname
            },
            set(value) {
                this.$store.commit("editCertificate", { lastname: value })
            }
        },
        email: {
            get() {
              if(this.userAction == "add") return ""
              return this.$store.getters.currentCertificate.email
            },
            set(value) {
                this.$store.commit("editCertificate", { email: value })
            }
        },
        galileoCode: {
            get() {
              if(this.userAction == "add") return ""
              return this.$store.getters.currentCertificate.galileoCode
            },
            set(value) {
                this.$store.commit("editCertificate", { galileoCode: value })
            }
        },
        issued: {
            get() {
              if(this.userAction == "add") return ""
              return this.$store.getters.currentCertificate.issued
            },
            set(value) {
                this.$store.commit("editCertificate", { issued: value })
            }
        },
        course: {
            get() {
              if(this.userAction == "add") return ""
              return this.$store.getters.currentCertificate.course
            },
            set(value) {
                this.$store.commit("editCertificate", { course: value })
            }
        },
        achievement: {
            get() {
              if(this.userAction == "add") return ""
              return this.$store.getters.currentCertificate.achievement
            },
            set(value) {
                this.$store.commit("editCertificate", { achievement: value })
            }
        }
    },
    watch: {
        actionTrigger: function(newVal, oldVal) {
          if (this.userAction == 'edit') {
            this.actionBtn = "update"
            this.name = this.userData.name;
            this.lastname = this.userData.lastname;
            this.email = this.userData.email;
            this.galileoCode = this.userData.galileoCode
            this.achievement = this.userData.achievement;
          }
        }
    },
    data() {
        return {
          es: es,
          actionBtn: "add",
          inputClass: "form-control"
        }
    },
    methods: {
        async getCourses() {
            try {
                await this.$store.dispatch('getCourses')
            } catch (error) {
              console.log(error)
                console.log('Error al obtener cursos')
            }
        },
        currentCertificate(certificate) {
            this.$store.commit('setCertificate', certificate)
        },
        async submit() {
            let courseData = this.courses.find(doc => doc.id === this.$store.getters.currentCertificate.course)
            let maxCert = courseData.maxCert
            let emitedCert = parseInt(courseData.emitedCert, 10)
            this.courseDoc = courseData.id
            let userExists = await this.$store.getters.existsEmail(courseData.id, this.$store.getters.currentCertificate.email);
            if (userExists == 1) {
              this.$toasted.show('Este Email ya existe.', {type: "error"})
              return
            }

            if (emitedCert >= maxCert) {
                this.toggleModal()
                this.$store.commit("cleanCertificate")
                this.$toasted.show('Se genero ya el máximo de diplomas', {type: "error"})
                return
            }

            this.$store.commit("editCertificate", { courseName: courseData.name })
            this.$store.commit("editCertificate", { effort: courseData.effort })

            let issuedDate = new Date(this.$store.getters.currentCertificate.issued)
            const months = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octumbre','Noviembre','Diciembre']
            const monthName = months[issuedDate.getMonth()]
            const year = issuedDate.getFullYear()
            const date = issuedDate.getDate()
            const formatted = `${date} ${monthName} ${year}`
            this.$store.commit("editCertificate", { dateFormatted: formatted })

            let certFields = {
                name: this.$store.getters.currentCertificate.name,
                lastname: this.$store.getters.currentCertificate.lastname,
                course: courseData.name,
                galileoCode: this.$store.getters.currentCertificate.galileoCode,
                issued: this.$store.getters.currentCertificate.issued
            }

            if (this.$store.getters.currentCertificate.email) {
                certFields.email = this.$store.getters.currentCertificate.email
            }
            if (this.$store.getters.currentCertificate.achievement) {
                certFields.achievement = this.$store.getters.currentCertificate.achievement
            }
            let validation = await this.validateFields(certFields)
            certFields.status = 0
            certFields.createdAt = new Date()
            certFields.isSigned = false

            if (validation) {
                let newCertRef = await firebase.firestore().collection("entities").doc(courseData.id).collection("certificates").add(certFields)
                emitedCert++
                let updateCourseRef = await firebase.firestore().collection("courses").doc(courseData.id).update({
                    emitedCert: emitedCert
                })

                this.$store.commit("setCertificateSaved", { courseId: courseData.id })
                this.toggleModal()
                this.$store.commit("cleanCertificate")
                this.$toasted.show('Datos del diploma guardados')
            } else {
                this.$toasted.show('Todos los campos son requeridos', {type: "error"})
            }
        },
        toggleModal() {
          this.name = ""
          this.lastname = "",
          this.email =  "",
          this.galileoCode = "",
          this.achievement = "",
          this.issued = "",
          this.course = "",
          this.actionBtn = "add",
          this.$store.commit("setUserAction", "add")
          this.$store.dispatch("toggleModalAddCertificate");
        },
        async updateUser(userId) {
          const dataEdit = await this.$store.getters.currentCertificate
          const currentCourse = this.$store.getters.currenCourse
          firebase
            .firestore()
            .collection("entities")
              .doc(currentCourse)
            .collection("certificates")
              .doc(userId)
            .update({
              name: dataEdit.name,
              lastname: dataEdit.lastname,
              email: dataEdit.email,
              galileoCode: dataEdit.galileoCode,
              achievement: dataEdit.achievement || ""
            })
            this.toggleModal();
            this.$toasted.show('Usuario actualizado')
            this.action = "edit"
        },
        validateFields(fields) {
            let emptyFields = []
            for (const [key, value] of Object.entries(fields)) {
                if (!value) {
                    emptyFields.push(key)
                }
            }
            return (emptyFields.length > 0) ? false : true
        }
    },
    components: {
        Datepicker
    }
}
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    -webkit-transition: opacity 500ms ease-in;
    -moz-transition: opacity 500ms ease-in;
    transition: opacity 500ms ease-in;
}
.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}
.modal-header {
    background-color: #007bff;
    color: #fefefe;
}
.modal-header span {
    color: #fefefe;
}
.vdp-datepicker__calendar {
    position: fixed;
}
.form-group {
    margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ModalAddCertificate.vue